const CODE = 'ExpiredPassword';

export class ExpiredPasswordError extends Error {
  constructor() {
    super(CODE);
    this['error'] = { code: CODE };
  }
}
